<template>
    <section :class="props.bgColor" class="py-10">
        <UContainer>
            <div class="flex flex-col items-center justify-center gap-8 md:grid md:grid-cols-2 lg:grid lg:grid-cols-3">
                <LandingCardHorizontal
                    to="/corporate/book-a-discovery-call"
                    title="Book a Discovery Call"
                    description="Book your free, no obligation consultation with our representative."
                    icon="i-bi-telephone"
                    iconColor="green"
                    color="blue" />

                <LandingCardHorizontal
                    to="/corporate/core-values"
                    title="Core Values"
                    description="Corporate social responsibility serves as the basis for all our decisions."
                    icon="i-bi-award"
                    iconColor="green"
                    color="blue" />

                <LandingCardHorizontal
                    to="/corporate/meet-the-team"
                    title="Meet the Team"
                    description="Dedicated to producing the world’s best quality sustainable agarwood using permaculture principles."
                    icon="i-bi-people"
                    iconColor="green"
                    color="blue" />

                <LandingCardHorizontal
                    to="/corporate/careers"
                    title="Careers"
                    description="We seek a motivated and ambitious people to join our team."
                    icon="i-bi-person-plus"
                    iconColor="green"
                    color="blue" />

                <LandingCardHorizontal
                    to="/corporate/investor-relations"
                    title="Investor Relations"
                    description="A company dedicated to producing the world’s best quality sustainable agarwood using permaculture principles."
                    icon="i-carbon-chart-relationship"
                    iconColor="green"
                    color="blue" />

                <LandingCardHorizontal
                    to="/corporate/contact-us"
                    title="Contact Us"
                    description="We are always open for any suggestions and collaborations."
                    icon="i-bi-pin-map"
                    iconColor="green"
                    color="blue" />
            </div>
        </UContainer>
    </section>
</template>

<script setup>
    const props = defineProps({
        bgColor: {
            type: String,
            default: 'bg-white dark:bg-gray-800',
            required: false
        }
    })
</script>
